module.exports = __webpack_public_path__ + "img/b955623.jpg";